import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=8157ae74&"
import script from "./Login.vue?vue&type=script&lang=js&"
export * from "./Login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1983107846/src/bitbucket.org/atsuboi/chatbot/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8157ae74')) {
      api.createRecord('8157ae74', component.options)
    } else {
      api.reload('8157ae74', component.options)
    }
    module.hot.accept("./Login.vue?vue&type=template&id=8157ae74&", function () {
      api.rerender('8157ae74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Auth/Login.vue"
export default component.exports